export default __webpack_public_path__ + "static/media/true-patient.6c60cbf3.png";